module.exports = __webpack_public_path__ + "static/media/playtreksTransparentBg.7dbca982.png";